import React, { FunctionComponent, useState, Suspense } from "react"
import HeaderEditorial from "./HeaderEditorial"
import { useBreakpoints } from "utils/breakpoints"
import MenuEditorial from "./MenuEditorial"
import PhoneModal from "../molecules/PhoneModal";

const FooterEditorial = React.lazy(() => import("./FooterEditorial"));

interface LayoutProps {
  children: string | JSX.Element;
  dashboard?: boolean;
  className?: string;
}

const Layout: FunctionComponent<LayoutProps> = ({
  children,
  dashboard,
  className = ""
}) => {
  const breakpoints = useBreakpoints();

  const [phoneModalOpen, setPhoneModalOpen] = useState<boolean>(false);

  const togglePhoneModalOpen = () => setPhoneModalOpen((state: boolean) => !state);

  return (
    <>
        {breakpoints.isMdOrLess ? (
          <>
            <HeaderEditorial togglePhoneModalOpen={togglePhoneModalOpen} hasDashboard={false}/>
            <MenuEditorial togglePhoneModalOpen={togglePhoneModalOpen} />
          </>
        ) : <HeaderEditorial togglePhoneModalOpen={togglePhoneModalOpen} hasDashboard={false}/>}

      <main className={`Main ${dashboard ? " Dashboard" : ""}`}>
        <div className={`app-content ${className}`}>
          {children}
        </div>
      </main>

      {
        <Suspense fallback={<div>Chargement...</div>}>
          <FooterEditorial togglePhoneModalOpen={togglePhoneModalOpen} />
        </Suspense>
      }

      <PhoneModal open={phoneModalOpen} onClose={togglePhoneModalOpen} />
    </>
  )
}

export default Layout
